<div fxLayout="column">
    <h2 fxFlex="0 0 auto" mat-dialog-title>Manual Correction</h2>
    <mat-dialog-content fxFlex="auto">
        <form class="correction-form" [formGroup]="correctionFormGroup" novalidate>
            <div fxLayout="column" fxLayoutGap="20px">
                <div fxFlex="auto" fxLayout="row wrap">
                    <mat-form-field fxFlex="1 1 10%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'currency'" fxFlex="1 1 auto" placeholder="Ccy" floatPlaceholder="always" formControlName="currency"
                            (selectionChange)="onFieldChange($event)" name="currency">
                            <mat-option *ngFor="let currency of currencies" [value]="currency">
                                {{ currency }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="0 1 25%">
                        <input matInput [matDatepicker]="settleDateDatePicker" formControlName="settleDate" name="settleDate" placeholder="Settle Date">
                        <mat-datepicker-toggle matSuffix [for]="settleDateDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #settleDateDatePicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 25%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'desk'" fxFlex="1 1 auto" placeholder="Desk" floatPlaceholder="always" formControlName="desk"
                            (selectionChange)="onFieldChange($event)" name="desk">
                            <mat-option *ngFor="let desk of desks" [value]="desk">
                                {{ desk }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 10%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'direction'" fxFlex="1 1 auto" placeholder="Dir" floatPlaceholder="always" formControlName="direction"
                            (selectionChange)="onFieldChange($event)" name="direction">
                            <mat-option *ngFor="let direction of directions" [value]="direction">
                                {{ direction }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 auto" (change)="onFieldChange($event)">
                        <span matPrefix>{{data.correction.direction === 'PAY' ? '- ' : ''}}</span>
                        <input matInput required placeholder="Amount" type="number" name="amount" formControlName="amount">
                        <mat-hint> {{ amountDisplay }}</mat-hint>
                    </mat-form-field>
                </div>
                <div fxFlex="auto" fxLayout="row wrap">
                    <mat-form-field fxFlex="1 1 40%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'organization-level'" fxFlex="1 1 auto" placeholder="Org Level" floatPlaceholder="always"
                            formControlName="organizationLevel" name="organizationLevel">
                            <mat-option *ngFor="let organizationLevel of organizationLevels" [value]="organizationLevel">
                                {{ organizationLevel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 60%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'client'" fxFlex="1 1 auto" placeholder="Client" floatPlaceholder="always" formControlName="client"
                            name="client">
                            <mat-option *ngFor="let client of clients" [value]="client">
                                {{ client }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="auto" fxLayout="row wrap">
                    <mat-form-field fxFlex="1 1 40%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'product'" fxFlex="1 1 auto" placeholder="Product" floatPlaceholder="always" formControlName="product"
                            name="product">
                            <mat-option *ngFor="let product of products" [value]="product">
                                {{ product }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 60%" fxFlex.lt-md="1 1 auto">
                        <mat-select required [ngClass]="'account'" fxFlex="1 1 auto" placeholder="Account" floatPlaceholder="always" formControlName="account"
                            name="account">
                            <mat-option *ngFor="let account of accounts" [value]="account">
                                {{ account }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="auto" fxLayout="row wrap">
                    <mat-checkbox fxFlex="1 1 25%" fxFlex.lt-md="1 1 auto" formControlName="timeSpecific" (change)="onFieldChange($event)">Time Specific</mat-checkbox>
                    <mat-form-field fxFlex="1 1 25%" fxFlex.lt-md="1 1 auto">
                        <input matInput placeholder="Time" type="time" name="settleTime" formControlName="settleTime">
                    </mat-form-field>
                    <mat-checkbox fxFlex="1 1 25%" fxFlex.lt-md="1 1 auto" formControlName="clearing">Clearing</mat-checkbox>

                    <!-- <mat-form-field class="text-align-end" fxFlex="0 1 auto">
                      <input matInput class="text-align-end" placeholder="Original Percentage" disabled [value]="data.correction.assumptionOriginalPercentage">
                      <mat-hint align="end">Assumption Amount: {{(data.correction.assumptionOriginalAmount * data.correction.assumptionOriginalPercentage
                          / 100) | number : '1.1-1'}}
                      </mat-hint>
                  </mat-form-field> -->
                    <!-- <mat-form-field class="text-align-end" fxFlex="0 1 auto">
                      <input matInput type="number" min="0" max="100" class="text-align-end" maxlength="3" required placeholder="New Percentage"
                          [(ngModel)]="data.correction.assumptionNewPercentage" name="assumptionNewPercentage">
                      <mat-hint align="end">{{ (data.correction.assumptionOriginalAmount * data.correction.assumptionNewPercentage / 100) | number
                          : '1.1-1'}}
                      </mat-hint>
                  </mat-form-field> -->
                </div>
                <div fxLayout="row">
                    <mat-form-field fxFlex="auto">
                        <input matInput placeholder="Reason" required formControlName="changeReason" name="changeReason">
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <div fxFlexFill>
        <span> </span>
    </div>

    <mat-dialog-actions fxFlex="0 0 auto" align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="primary" [disabled]="!correctionFormGroup.valid" (click)="submit()" [mat-dialog-close]="submitResult">Submit</button>
    </mat-dialog-actions>

</div>